import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 피스톤 디자인 시스템
import './design-system/styles/base.css'
import './design-system/styles/dark-mode.css'
import './design-system/styles/micro-interactions.css'
import './design-system/styles/piston-theme.css'
import './design-system/styles/liquid-glass.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCoffee,
  faUser,
  faHome,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { tokenStore } from './store/tokenStore'

library.add(faCoffee, faUser, faHome, faChevronRight)

const app = createApp(App).use(store).use(router)

app.config.globalProperties.$tokenStore = tokenStore
app.component('font-awesome-icon', FontAwesomeIcon)
app.provide('tokenStore', tokenStore)

// 기기정보
window.myFunction = (parameter) => {
  app.config.globalProperties.$store.dispatch('SET_DEIVICE_INFO', parameter)
}

// 위치정보
window.setLocationInfo = (parameter) => {
  app.config.globalProperties.$store.dispatch('SET_LOCATION_INFO', parameter)
}

// 시스템 알림설정 정보
window.pushInfo = (parameter) => {
  app.config.globalProperties.$store.dispatch('SET_PUSH_INFO', parameter)
}

// 카카오 로그인
window.snsLogin = (parameter) => {
  app.config.globalProperties.$store.dispatch('SNS_LOGIN', parameter)
}

// 출입캠퍼스 변경
window.accessMobile = (parameter) => {
  app.config.globalProperties.$store.dispatch('ACCESS_INIT', parameter)
}
// 비콘 스캔
window.endScan = (parameter) => {
  app.config.globalProperties.$store.dispatch('SET_BLE_SCAN', parameter.result)
}

// 알림 상세 이동
window.pushView = (parameter) => {
  const param = JSON.parse(parameter)

  if (param.cat === 'ATD') {
    app.config.globalProperties.$store.dispatch('SET_PUSH_ATDC')
  } else if (param.cat === 'NOTICE') {
    app.config.globalProperties.$store.dispatch('SET_PUSH')
  } else {
    app.config.globalProperties.$store.dispatch('SET_PUSH')
  }
}

app.mount('#app')
